export default {"src":"/_next/static/media/design.ddcc1e0c.svg","height":261,"width":280,"blurWidth":0,"blurHeight":0};